const Embellishment = () => {
  const linkSvg =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.125 0.700041L15.725 7.30004C15.825 7.40004 15.896 7.50837 15.938 7.62504C15.9793 7.74171 16 7.86671 16 8.00004C16 8.13337 15.9793 8.25837 15.938 8.37504C15.896 8.49171 15.825 8.60004 15.725 8.70004L9.125 15.3C8.94167 15.4834 8.71267 15.5794 8.438 15.588C8.16267 15.596 7.925 15.5 7.725 15.3C7.525 15.1167 7.42067 14.8877 7.412 14.613C7.404 14.3377 7.5 14.1 7.7 13.9L12.6 9.00004L1.425 9.00004C1.14167 9.00004 0.904 8.90437 0.712 8.71304C0.520666 8.52104 0.424999 8.28337 0.424999 8.00004C0.424999 7.71671 0.520666 7.47937 0.712 7.28804C0.904 7.09604 1.14167 7.00004 1.425 7.00004L12.6 7.00004L7.7 2.10004C7.51667 1.91671 7.42067 1.68337 7.412 1.40004C7.404 1.11671 7.5 0.883374 7.7 0.700041C7.88333 0.500041 8.11667 0.40004 8.4 0.40004C8.68333 0.40004 8.925 0.500041 9.125 0.700041Z" fill="currentColor"/></svg>';

  // styled links
  function addLinkIcon(selector) {
    document.querySelectorAll(selector).forEach((el) => {
      if (
        !el.classList.contains("fileExt--link") &&
        el.getAttribute("rel") !== "external"
      ) {
        el.insertAdjacentHTML("afterbegin", linkSvg);
        el.classList.add("arrow-link");
      }
    });
  }

  // max width
  document.querySelectorAll(".moj__blocks__blockrelated").forEach((el) => {
    if (el.querySelectorAll(".inner__max").length > 0) {
      el.classList.add("moj__blocks__blockrelated--max");
    }
  });

  document.querySelectorAll(".rte .fileExt").forEach((el) => {
    // replace the [] with ()
    el.textContent = el.textContent.replace("[", "(").replace("]", ")");

    const linkElement = el.closest("a");

    if (!linkElement) {
      return;
    }

    linkElement.classList.add("fileExt--link");

    const supportedCustomIcons = {
      "fileExt--pdf": "pdf",
      "fileExt--doc": "doc",
      "fileExt--xls": "xls",
      "fileExt--ppt": "ppt",
      "fileExt--brf": "brf",
      "fileExt--mp3": "mp3",
      "fileExt--zip": "zip",
    };

    Object.keys(supportedCustomIcons).forEach((iconClass) => {
      const extension = supportedCustomIcons[iconClass];

      if (linkElement.classList.contains(iconClass)) {
        return;
      }

      if (el.textContent?.toLowerCase().includes(extension)) {
        linkElement.classList.add(iconClass);
        return;
      }
    });
  });

  // .content-element__content-resource a:only-child should be upgraded to feature link
  document
    .querySelectorAll(".content-element__content-resource a:only-child")
    .forEach((el) => {
      el.classList.add("featured-link");

      // add a helper class to the parent p tag to indicate that it has a featured
      // link in it
      el.closest("p").classList.add("has--featured-link");
    });

  // add the `content` id to the first element block
  const first = document.querySelector(".element");

  if (first) {
    first.id = "content";
  }

  document.querySelectorAll(".block-featured-links__links").forEach((el) => {
    if (el.querySelectorAll(".featured-tile").length > 0) {
      el.classList.add("has--featured-links");
    }
  });

  addLinkIcon(".block-alert p a:only-child");
  addLinkIcon(".block-alternative-formats__content a");
};

export default Embellishment;
